import { render, staticRenderFns } from "./F2FNGWordsChart.vue?vue&type=template&id=0202aef1"
import script from "./F2FNGWordsChart.vue?vue&type=script&lang=js"
export * from "./F2FNGWordsChart.vue?vue&type=script&lang=js"
import style0 from "./F2FNGWordsChart.vue?vue&type=style&index=0&id=0202aef1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports